export default {
  mounted() {
    try {
      // Get the event name from data-event-name attribute
      const eventName = this.el.dataset.eventName

      if (!eventName) {
        console.warn('ViewAnalyticsEvent hook requires data-event-name attribute')
        return
      }

      // Extract all data attributes as properties (except eventName)
      const properties = {}

      // Iterate through all dataset properties
      Object.entries(this.el.dataset).forEach(([key, value]) => {
        // Skip the eventName since that's used for the event itself
        if (key !== 'eventName' && key !== 'qa') {
          // Convert camelCase to snake_case for consistency with backend
          const snakeCaseKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
          properties[snakeCaseKey] = value
        }
      })

      // Send PostHog event when element is rendered/viewed
      if (typeof posthog !== 'undefined' && posthog) {
        posthog.capture(eventName, properties)

        console.log(`PostHog event sent: ${eventName}`, properties)
      } else {
        console.warn('PostHog not available when trying to track view event')
      }
    } catch (error) {
      console.error('Error tracking view analytics event:', error)
    }
  },
}
